import {
    CREATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK,
    CREATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK,
    CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK,
    CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS_DK,
    DELETE_IRONING_PACKING_DC_DETAILS_FAILURE_DK,
    DELETE_IRONING_PACKING_DC_DETAILS_REQUEST_DK,
    DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK,
    FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE_DK,
    FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST_DK,
    FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_FAILURE_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS_DK,
    IRONING_PACKING_DC_DETAILS_USERFORM_RESET_DK,
    UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK,
    UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK,
    UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST_DK_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS_DK_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE_DK_DK,
    FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST_DK_DK,
    FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS_DK_DK,
    FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE_DK_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE_DK,
    FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK,
    CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK,
    CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK,
    CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK,
    CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY_DK,
    RESET_IRONING_PACKING_DC_EDIT_QTY_DK,
    RESET_IRONING_PACKING_DC_DETAIL_INWARD_NO,
    FETCH_IRONING_PACKING_DC_DETAILS_EDIT_REQUEST_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_EDIT_SUCCESS_DK,
    FETCH_IRONING_PACKING_DC_DETAILS_EDIT_FAILURE_DK
} from './ironingPackingDCDetails.actionsType';

export const IRONING_PACKING_DC_DETAILS_DK = 'ironingPackingDcDetailsDK';

let initialState = {
    loading: false,
    ironingPackingDCDetailsById: [],
    ironingPackingDCDetails: [],
    ironingPackingDCDetailsDcNo: [],
    grnNoByIroningPackingDcNo: [],
    editIroningPackingQtyList: [],
    ironingPackingDCDetailsProgram: [],
    ironingPackingDCDetailsEdit: [],
    userform: {
        fldRate: 0,
        fldQuantity: 0,
        fldGrossValue: 0,
        fldDiscountValue: 0,
        fldIGSTValue: 0,
        fldSGSTValue: 0,
        fldCGSTValue: 0,
        fldTaxableValue: 0,
        fldGSTValue: 0,
        fldSGSTPercentage: 0,
        fldCGSTPercentage: 0,
        fldIGSTPercentage: 0
    },
    selectedIroningPackingDC2Details: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let ironingPackingDCDetailsDKReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    if (type === FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS_DK_DK) {
        localStorage.setItem('InwardNO', JSON.stringify(updatePayload));
    }
    switch (type) {
        case FETCH_IRONING_PACKING_DC_DETAILS_REQUEST_DK:
        case FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_REQUEST_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_REQUEST_DK:
        case FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_REQUEST_DK_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_REQUEST_DK_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_REQUEST_DK:
        case CREATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK:
        case CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_REQUEST_DK:
        case FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_REQUEST_DK:
        case UPDATE_IRONING_PACKING_DC_DETAILS_REQUEST_DK:
        case DELETE_IRONING_PACKING_DC_DETAILS_REQUEST_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_EDIT_REQUEST_DK:
            return {
                ...state,
                loading: true
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetails: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editIroningPackingQtyList: updatePayload
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsProgram: updatePayload?.Program
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_BY_ID_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsById: updatePayload
            };
        case FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                grnNoByIroningPackingDcNo: updatePayload?.Inward
            };
        case RESET_IRONING_PACKING_DC_DETAIL_INWARD_NO:
            return {
                ...state,
                loading: false,
                grnNoByIroningPackingDcNo: payload?.Inward
            };

        case CREATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editIroningPackingQtyList: updatePayload?.IPD,
                dataRefresh: updatePayload?.IPD?.length,
                QtyLoad: updatePayload?.IPD?.map((x) => x.qty)
            };
        case RESET_IRONING_PACKING_DC_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                editIroningPackingQtyList: []
            };
        case CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                editPrintingQtyList: [],
                userform: {
                    ...state.userform,
                    InwardNO: []
                }
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_SUCCESS_DK_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsDcNo: updatePayload?.IPD
            };
        case FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC2Details: updatePayload[0],
                userform: updatePayload[0]
            };
        case UPDATE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                selectedIroningPackingDC2Details: {},
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                }
            };
        case DELETE_IRONING_PACKING_DC_DETAILS_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedIroningPackingDC2Details: {}
            };
        case FETCH_IRONING_PACKING_DC_DETAILS_EDIT_SUCCESS_DK:
            return {
                ...state,
                loading: false,
                ironingPackingDCDetailsEdit: updatePayload?.IPD
            };

        case FETCH_IRONING_PACKING_DC_DETAILS_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_DETAIL_EDIT_QUANTITY_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_PROGRAM_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_DC_NO_FAILURE_DK_DK:
        case FETCH_GRN_NO_BY_IRONING_PACKING_DC_NO_FAILURE_DK_DK:
        case FETCH_SINGLE_IRONING_PACKING_DC_DETAILS_FAILURE_DK:
        case CREATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK:
        case CREATE_IRONING_PACKING_DC_DETAIL_EDIT_QTY_MASTER_FAILURE_DK:
        case UPDATE_IRONING_PACKING_DC_DETAILS_FAILURE_DK:
        case DELETE_IRONING_PACKING_DC_DETAILS_FAILURE_DK:
        case FETCH_IRONING_PACKING_DC_DETAILS_EDIT_FAILURE_DK:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_IRONING_PACKING_DC_DETAILS_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_IRONING_PACKING_DC_EDIT_QTY_DK:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform
                },
                editIroningPackingQtyList: payload
            };
        case IRONING_PACKING_DC_DETAILS_USERFORM_RESET_DK:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0
                },
                selectedIroningPackingDC2Details: {}
            };
        default:
            return state;
    }
};
